/**
 * Подсказка годовой оплаты по акции.
 *
 * Показывается в формах оплаты (гость и авторизованный клиент), когда ссылка
 * Telegram-бота содержит признак годовой оплаты (`annual=1`).
 */

import React from 'react';
import { Alert, Typography } from '@mui/material';

/**
 * Информационный блок «Оплата за год по акции».
 *
 * @returns Alert с пояснением о бонусе за годовую оплату
 *
 * @example
 * {annual && <AnnualPaymentHint />}
 */
export function AnnualPaymentHint() {
  return (
    <Alert severity="info" sx={{ py: 0 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Оплата за год по акции
      </Typography>
      <Typography variant="body2">
        После зачисления платежа на счёт будет начислен бонус.
      </Typography>
    </Alert>
  );
}
